import { createHooks } from "hookable";

const hooks = createHooks<{
  "session-changed": (session: AppUserSession) => void;
}>();

export function useAppSession() {
  const serverEvent = useRequestEvent();
  const sessionState = useState<AppUserSession>("app-session", () => ({}));
  const authReadyState = useState("app-session-ready", () => false);

  async function clear() {
    await useRequestFetch()("/api/auth/logout", {
      method: "POST",
      onResponse: useCookieForwardingOnResponse(serverEvent),
    });
    sessionState.value = {};
  }

  async function fetch() {
    sessionState.value = await useRequestFetch()("/api/auth/session", {
      onResponse: useCookieForwardingOnResponse(serverEvent),
    }).catch(() => ({}));

    if (!authReadyState.value) {
      authReadyState.value = true;
    }
  }
  // Permission management

  function hasAnyPermission(permissionSuffix: PermissionSuffix) {
    if (!sessionState.value.permissions) return false;

    return hasAnyPermissionWithSuffix(
      sessionState.value.permissions,
      permissionSuffix,
    );
  }
  function useCustomersWithPermission(
    permissionSuffix: PermissionSuffix,
  ): ComputedRef<string[]> {
    return computed(() => {
      if (!sessionState.value.permissions) return [];

      return sessionState.value.permissions.reduce<string[]>(
        (customerIds, permission) => {
          const split = splitPermission(permission);
          if (!split) return customerIds;
          const [customerId, suffix] = split;
          if (suffix === permissionSuffix) {
            customerIds.push(customerId);
          }
          return customerIds;
        },
        [],
      );
    });
  }
  watch(sessionState, (value) => {
    hooks.callHook("session-changed", value);
  });

  return {
    ready: computed(() => authReadyState.value),
    loggedIn: computed(() => Boolean(sessionState.value.user)),
    user: computed(() => sessionState.value.user || null),
    session: sessionState,
    hasAnyPermission,
    useCustomersWithPermission,
    fetch,
    clear,
    hooks,
  };
}
